import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
  gap: 8px;
`;

export const CatalogItemName = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 32px;
  text-transform: uppercase;
  font-family: ${FONTS.ARTZ};
`;

export const DurationTagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
